import React from 'react';
import PropTypes from 'prop-types';
import { FDNumberInput } from '@facet-wealth/design';
import { useYearPicker } from 'Components/ComponentLibrary/Molecules/dateOrYearPicker/useYearPicker';
import { DateInputLarge } from 'Packages/FacetDesign/Components';

export default function DateOrYearPickerLeftLabelPlacement({
  value, onChange, label, disabled, startDateField, yearLabel, helperTextValue, inputFormat, isAge, onBlur, onInlineSubmit,
}) {
  const yearPicker = useYearPicker({
    startDateField,
    yearLabel,
    isAge,
    dateLabel: label,
    dateValue: value,
    dateOnChange: onChange,
  });
  return (
    <>
      <DateInputLarge
        value={value}
        onChange={onChange}
        disabled={disabled}
        label={label}
        helperTextValue={helperTextValue}
        inputFormat={inputFormat}
        labelPlacement={'left'}
        onBlur={onBlur}
        onInlineSubmit={onInlineSubmit}
        flex={1}
      />
      {
        yearPicker ? (
          <FDNumberInput
            flex={1}
            disabled={disabled}
            labelPlacement={'left'}
            onBlur={onBlur}
            onInlineSubmit={onInlineSubmit}
            {...yearPicker}
          />
        ) : null
      }
    </>
  );
}

DateOrYearPickerLeftLabelPlacement.defaultProps = {
  value: undefined,
  label: undefined,
  disabled: false,
  isAge: false,
  yearLabel: undefined,
  helperTextValue: undefined,
  inputFormat: undefined,
};

DateOrYearPickerLeftLabelPlacement.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  startDateField: PropTypes.string.isRequired,
  isAge: PropTypes.bool,
  yearLabel: PropTypes.string,
  helperTextValue: PropTypes.string,
  inputFormat: PropTypes.string,
};
